import VideoChat from './videoChat';

let defaultOptions = {
    nickname: false
};

class VisitaChat extends VideoChat {

    constructor(url, options) {
        options = {
            ...options,
            ...defaultOptions
        };
        
        super(url, options);

        this.socket.on('disconnect', data => {
            // console.log('disconnected', data);
            if (data === "io server disconnect") {
                // the disconnection was initiated by the server, you need to reconnect manually
                this.socket.connect();
            }
        });
    }

    authenticate(token) {
        this.socket.emit('authenticate', token);
    }

    patients() {
        this.socket.emit('patients');
    }

}

export default VisitaChat;